import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import TableDataLayerDfos from "../components/TableDataLayerDfos";

const TableDataPageDfos = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
          <Breadcrumb title="DFOs List" tooltipContent="Add New DFOs" linkTo="/dfo-form"  requiredPermission={{ module: 'dfo_list', action: 'create' }} />
    
        {/* TableDataLayerDfos */}
        <TableDataLayerDfos  />

      </MasterLayout>

    </>
  );
};

export default TableDataPageDfos; 
